/** @jsx jsx */
import { jsx } from "theme-ui";
import { FunctionComponent } from "react";

export const SewingMachine: FunctionComponent<{
  className?: string;
}> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 512 512">
      <path
        className="white"
        d="M167,270.34v12.24a8.53,8.53,0,0,0,8.51,8.5h20.79a8.52,8.52,0,0,0,8.5-8.5V270.34Z"
      />
      <path
        className="lobsterLight"
        d="M363.07,94.86H343.43a7.26,7.26,0,0,0-7.26,7.21v33.42a7.26,7.26,0,0,0,7.26,7.22h19.64a7.26,7.26,0,0,0,7.26-7.22V102.07A7.26,7.26,0,0,0,363.07,94.86Z"
      />
      <path
        className="lobster"
        d="M353.25,135.49V102.07a7.26,7.26,0,0,1,7.26-7.21H343.43a7.26,7.26,0,0,0-7.26,7.21v33.42a7.26,7.26,0,0,0,7.26,7.22h17.08A7.26,7.26,0,0,1,353.25,135.49Z"
      />
      <path
        className="skyBlueLight"
        d="M360.51,142.71H191.6a49.08,49.08,0,0,0-49.08,49.08v65.58a15.05,15.05,0,0,0,15,15.05h56.56a15.05,15.05,0,0,0,15.06-15.05v-14.9a13.09,13.09,0,0,1,13.09-13.09h67.55a13.09,13.09,0,0,1,13.1,13.09V331.2H409.6V191.79a49.08,49.08,0,0,0-49.09-49.08Z"
      />
      <path
        className="skyBlueMedium"
        d="M334.27,229.38H309.83a13.09,13.09,0,0,1,13.1,13.09V331.2h24.43V242.47a13.09,13.09,0,0,0-13.09-13.09Z"
      />
      <path
        className="skyBlueLight"
        d="M177.41,246.43a8.44,8.44,0,0,0,8.44-8.45V183.4a8.44,8.44,0,0,0-8.44-8.44H145.48a48.91,48.91,0,0,0-3,16.83v54.64Z"
      />
      <path
        className="skyBlueMedium"
        d="M167,257.37V191.79c0-.8,0-1.59.06-2.38,0-.26,0-.52.05-.78,0-.53.07-1,.12-1.56,0-.31.07-.62.1-.93.06-.47.11-.93.18-1.39l.15-1c.07-.45.15-.89.24-1.33s.12-.64.19-1l.3-1.31c.08-.31.15-.63.24-.94.12-.46.25-.91.38-1.36l.24-.83c.23-.7.46-1.4.71-2.09h0A49.11,49.11,0,0,1,216,142.71H191.6A49.1,49.1,0,0,0,145.48,175h0a49.45,49.45,0,0,0-2.22,8.34l0,.17c-.1.59-.19,1.18-.27,1.78,0,.2-.05.4-.07.6-.06.49-.12,1-.16,1.48s-.06.72-.08,1.09-.06.72-.08,1.09c0,.76,0,1.52,0,2.27h0v65.58a15.05,15.05,0,0,0,15,15.05H182A15.05,15.05,0,0,1,167,257.37Z"
      />
      <circle className="midnightLight" cx="382.53" cy="229.11" r="38.49" />
      <path
        className="midnightMedium"
        d="M366.63,229.11a38.51,38.51,0,0,1,27.2-36.8,38.5,38.5,0,1,0,0,73.61,38.51,38.51,0,0,1-27.2-36.81Z"
      />
      <circle className="midnightLight" cx="382.53" cy="229.11" r="18.2" />
      <path
        className="midnightMedium"
        d="M382.53,229.11a18.2,18.2,0,0,1,9.1-15.76,18.21,18.21,0,1,0,0,31.52A18.17,18.17,0,0,1,382.53,229.11Z"
      />
      <path
        className="skyBlueLightest"
        d="M126.5,420.62h0v-91.5H114.08a11,11,0,0,0-10.92,11.06v58.41H98.52a7.81,7.81,0,0,0-7.8,7.79v13.47a7.82,7.82,0,0,0,7.8,7.8h35A7,7,0,0,1,126.5,420.62Z"
      />
      <path
        className="skyBlueLightest"
        d="M413.23,398.59H409.6V329.12H216.2v91.5a7,7,0,0,1-7,7H413.23a7.81,7.81,0,0,0,7.79-7.8V406.38A7.81,7.81,0,0,0,413.23,398.59Z"
      />
      <path
        className="skyBlueLight"
        d="M126.5,420.62v-7.5h-28a7.82,7.82,0,0,1-7.77-7.27,4.71,4.71,0,0,0,0,.53v13.47a7.82,7.82,0,0,0,7.8,7.8h35a7,7,0,0,1-7-7Z"
      />
      <path
        className="skyBlueLight"
        d="M413.23,413.12h-197v7.5a7,7,0,0,1-7,7H413.23a7.82,7.82,0,0,0,7.79-7.8V406.38c0-.18,0-.35,0-.53a7.82,7.82,0,0,1-7.77,7.27Z"
      />
      <path
        className="lobsterLight"
        d="M213.32,321.8H131.45a7,7,0,0,0-7,7v91.79a7,7,0,0,0,7,7h81.87a7,7,0,0,0,7-7V328.83a7,7,0,0,0-7-7Z"
      />
      <path
        className="lobster"
        d="M151.11,420.62V328.83a7,7,0,0,1,7-7H131.45a7,7,0,0,0-7,7v91.79a7,7,0,0,0,7,7h26.69a7,7,0,0,1-7-7Z"
      />
      <path
        className="midnight"
        d="M189.09,338.26a3.11,3.11,0,1,0-6.22,0v4.66a3.11,3.11,0,1,0,6.22,0Z"
      />
      <path
        className="midnight"
        d="M189.09,360.45a3.11,3.11,0,0,0-6.22,0v4.66a3.11,3.11,0,0,0,6.22,0Z"
      />
      <path
        className="midnight"
        d="M189.09,382.64a3.11,3.11,0,0,0-6.22,0v4.66a3.11,3.11,0,0,0,6.22,0Z"
      />
      <path
        className="midnight"
        d="M189.09,404.83a3.11,3.11,0,0,0-6.22,0v4.66a3.11,3.11,0,0,0,6.22,0Z"
      />
      <path
        className="midnight"
        d="M382.66,208A21.32,21.32,0,1,0,404,229.35,21.34,21.34,0,0,0,382.66,208Zm0,36.4a15.09,15.09,0,1,1,15.09-15.09A15.11,15.11,0,0,1,382.66,244.44Z"
      />
      <path
        className="midnight"
        d="M424.27,406.62a10.91,10.91,0,0,0-9.6-10.82l-1.83-.22V258l.54-.59a41.51,41.51,0,0,0,0-56l-.54-.59V192a52.34,52.34,0,0,0-38.4-50.34l-2.13-.58L373,139a10.05,10.05,0,0,0,.55-3.29V102.31A10.36,10.36,0,0,0,363.2,92h-6.71V84.11a3.12,3.12,0,0,0-6.23,0V92h-6.7a10.36,10.36,0,0,0-10.38,10.32v18.62H189.09v-4.39a3.11,3.11,0,0,0-6.22,0v4.39h-2.26a3.12,3.12,0,1,0,0,6.23h2.26v13.4l-1.66.34A52.38,52.38,0,0,0,139.53,192V257.6a18.19,18.19,0,0,0,18.17,18.17H164v7.05a11.64,11.64,0,0,0,11.62,11.62h7.28v9.13H178a3.11,3.11,0,1,0,0,6.22h4.92v9.13H131.58a10.15,10.15,0,0,0-9.29,6.09l-.54,1.24h-7.54a14.06,14.06,0,0,0-14,14v55.37l-2,.08a10.87,10.87,0,0,0-10.46,10.88v13.47A10.92,10.92,0,0,0,98.64,431H413.36a10.92,10.92,0,0,0,10.91-10.91ZM106.4,340.29a7.83,7.83,0,0,1,7.81-7.82h7.23v63.24h-15Zm-7.76,84.48A4.74,4.74,0,0,1,94,420.09V406.62a4.75,4.75,0,0,1,4.68-4.68h22.8v18.92a8.08,8.08,0,0,0,0,.93l.06.6.37,2.38ZM418,229.35A35.38,35.38,0,1,1,382.66,194,35.42,35.42,0,0,1,418,229.35Zm-78.63-127a4.18,4.18,0,0,1,4.15-4.1H363.2a4.18,4.18,0,0,1,4.15,4.1v33.42a4.18,4.18,0,0,1-4.15,4.1H343.56a4.18,4.18,0,0,1-4.15-4.1ZM189.09,127.16H333.18v8.57a9.59,9.59,0,0,0,.16,1.69l.39,2.41H191.19l-2.1,0ZM145.76,192a45.53,45.53,0,0,1,1.65-12.2l.42-1.52h29.7a5.34,5.34,0,0,1,5.34,5.33v54.58a5.34,5.34,0,0,1-5.34,5.33H145.76Zm11.94,77.51a12,12,0,0,1-11.94-11.94v-7.82h31.77a11.57,11.57,0,0,0,11.56-11.56V183.64a11.57,11.57,0,0,0-11.56-11.56H150.17L152,169a46.17,46.17,0,0,1,39.74-22.9H360.64a46.12,46.12,0,0,1,46,45.45l0,3.65-3.15-1.84a41.61,41.61,0,1,0,0,72.06l3.12-1.81v62.68H326.17V242.71A16.23,16.23,0,0,0,310,226.5H242.41a16.23,16.23,0,0,0-16.21,16.21V257.6a12,12,0,0,1-11.94,11.94Zm248.92,62.94v63.23h-183V332.48Zm-231-44.27a5.46,5.46,0,0,1-5.39-5.39v-7.05h31.58v7.05a5.46,5.46,0,0,1-5.39,5.39Zm41.78,132.65a3.91,3.91,0,0,1-3.91,3.91H131.58a3.92,3.92,0,0,1-3.92-3.91V329.07a3.93,3.93,0,0,1,3.92-3.92h81.87a3.92,3.92,0,0,1,3.91,3.92Zm-3.91-101.94H189.09v-9.13H194a3.11,3.11,0,1,0,0-6.22h-4.92v-9.14h7.29A11.63,11.63,0,0,0,208,282.82v-7.05h6.27a18.19,18.19,0,0,0,18.17-18.17V242.71a10,10,0,0,1,10-10H310a10,10,0,0,1,10,10v83.54H223.28l-.55-1.24A10.14,10.14,0,0,0,213.45,318.92ZM418,420.09a4.75,4.75,0,0,1-4.68,4.68H223.11l.4-2.71c0-.12,0-.19,0-.27,0-.35.05-.65.05-.93V401.94H413.36a4.75,4.75,0,0,1,4.68,4.68Z"
      />
    </svg>
  );
};
